export default __webpack_public_path__ + "a657e2620671b7c08a02e1bc9f64786a.jpg";